var _g, _g2, _g3, _g4, _g5, _g6, _g7, _g8, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgNoCoPilot(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 2245,
    height: 268,
    viewBox: "0 0 2245 268",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_d_9306_1300)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M398.823 259.926C393.124 259.926 389.218 259.99 385.034 259.999C373.573 259.926 371.835 256.627 371.31 248.042C371.93 221.217 371.29 194.373 371.669 167.543C371.785 159.191 369.587 152.161 364.714 144.805C335.217 100.294 306.498 55.3879 277.197 10.7759C272.373 3.43242 271.958 -0.399489 283.394 0.412711C283.969 0.453512 284.552 0.42963 285.129 0.413361C336.271 -1.0271 335.96 -0.878161 360.838 38.9919C380.177 69.9812 400.303 100.596 420.327 131.254C426.465 140.653 430.008 150.091 429.658 161.299C428.826 188.113 428.402 215 429.785 241.781C430.531 256.218 425.724 259.926 409.136 259.99C406.335 259.546 403.364 259.926 398.823 259.926Z",
    fill: "#645EFF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M500.79 56.1325C487.073 74.8612 473.848 92.6229 459.847 111.428C447.588 100.042 440.326 86.7129 430.944 74.5789C428.055 70.8428 431.052 67.2167 433.384 63.919C446.694 45.1116 460.145 26.3713 473.344 7.51316C476.852 2.50372 481.259 -0.123093 488.672 0.00443296C506.072 0.30376 523.483 0.100193 544.052 0.100193C528.846 19.6774 515.065 37.4215 500.79 56.1325Z",
    fill: "#D21D71"
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter1_d_9306_1300)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M1845.23 1.48798C1777.73 10.174 1733.45 60.1185 1733.02 128.738C1732.59 197.792 1778.59 249.907 1848.67 259.028C1877.47 262.937 1920.46 254.686 1946.26 240.788L1966.46 229.496V177.814V126.567H1942.82H1919.17V165.654C1919.17 204.306 1919.17 205.175 1907.56 209.952C1900.69 212.558 1883.92 215.164 1869.3 215.164C1847.38 215.598 1840.07 213.427 1822.44 202.569C1792.35 183.894 1780.31 159.139 1782.89 123.092C1784.61 100.943 1787.62 92.2568 1797.51 79.6622C1821.15 50.564 1829.75 46.2208 1869.3 46.2208C1901.55 46.2208 1906.7 47.5239 1923.04 58.8157L1941.1 71.4103L1955.71 57.0784L1970.76 42.3123L1960.87 31.8889C1939.81 8.43678 1890.8 -4.59222 1845.23 1.48798Z",
    fill: "#645EFF"
  }))), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter2_d_9306_1300)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M4 130V259.999H30.2886H56.577V204.915V149.83H125.883H195.189V204.915V259.999H223.868H252.546L251.591 130.881L250.156 2.20338H223.868H197.579L196.145 53.7627L194.711 105.763H125.883H56.577V52.8813V0H30.2886H4V130Z",
    fill: "#645EFF"
  }))), _g4 || (_g4 = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter3_d_9306_1300)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M576.773 130.219V259.999H602.614H628.452V222.731V185.463H671.206C723.826 185.463 749.195 179.764 771.277 162.664C795.239 144.249 803.225 127.15 803.696 95.5815C804.165 56.5598 789.6 33.7605 753.425 17.0995C727.585 4.82293 722.417 3.94602 651.473 2.19224L576.773 0V130.219ZM719.597 51.2984C748.726 62.6979 759.061 91.6356 744.028 119.258C734.161 136.796 717.718 141.619 670.737 141.619H628.452V93.3895V45.16H666.038C687.649 45.16 710.671 47.7907 719.597 51.2984Z",
    fill: "#645EFF"
  }))), _g5 || (_g5 = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter4_d_9306_1300)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M857.699 130.219V259.999H883.799H909.898V222.731V185.463H944.539H979.653L1007.18 222.731L1035.17 259.999H1065.54H1095.44L1063.64 217.47C1043.72 191.163 1033.75 174.502 1037.55 173.187C1048.46 169.679 1071.71 149.072 1079.3 135.919C1083.58 128.027 1086.9 110.927 1086.9 95.5815C1087.37 56.5598 1072.66 33.7605 1036.12 17.0995C1010.02 4.82293 1004.8 3.94602 933.149 2.19224L857.699 0V130.219ZM1001.96 51.2984C1031.38 62.6979 1041.82 91.6356 1026.63 119.258C1017.14 135.919 999.584 142.057 951.656 144.688L909.898 147.318V96.0199V45.16H947.861C969.688 45.16 992.941 47.7907 1001.96 51.2984Z",
    fill: "#645EFF"
  }))), _g6 || (_g6 = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter5_d_9306_1300)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M1419.55 130V259.999H1489.31C1567.27 259.999 1595.54 254.712 1627 233.559C1664.39 208.44 1681.72 170.983 1678.53 121.627C1675.34 74.4745 1655.27 43.1864 1614.24 20.2711C1586.43 4.84745 1554.96 0 1483.38 0H1419.55V130ZM1564.08 49.3559C1611.05 60.3728 1637.49 108.847 1622.44 156.44C1609.22 199.627 1579.13 215.932 1513.02 215.932H1469.7V130V44.0678H1506.63C1526.7 44.0678 1552.68 46.2711 1564.08 49.3559Z",
    fill: "#645EFF"
  }))), _g7 || (_g7 = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter6_d_9306_1300)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M2046.49 130V259.999H2143.97H2241L2239.68 238.847L2238.36 218.135L2166.91 216.813L2095.01 215.932V182.881V149.83H2157.21H2218.95L2217.64 128.678L2216.32 107.966L2155.88 106.644L2095.01 105.322V74.915V44.0678H2166.03H2236.59L2235.27 22.9152L2233.95 2.20338L2140.44 0.881353L2046.49 0V130Z",
    fill: "#645EFF"
  }))), _g8 || (_g8 = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter7_d_9306_1300)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M1327.24 216.666C1354.49 216.667 1354.49 216.667 1354.49 239.397C1354.49 242.569 1354.13 245.779 1354.56 248.906C1355.65 256.957 1352.45 260.056 1342.74 259.999C1285.33 259.659 1227.91 259.689 1170.5 259.98C1162.12 260.023 1159.4 257.361 1160.47 250.535C1160.54 250.091 1160.48 249.63 1160.47 249.176C1159.65 216.666 1159.65 216.666 1196.53 216.666C1239.59 216.666 1282.65 216.666 1327.24 216.666Z",
    fill: "#645EFF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1290.13 108.333C1311.32 108.335 1311.32 108.335 1311.32 131.065C1311.32 134.238 1311.05 137.448 1311.38 140.575C1312.23 148.624 1309.74 151.723 1302.18 151.665C1257.53 151.327 1212.87 151.358 1168.22 151.648C1161.7 151.69 1159.59 149.028 1160.42 142.202C1160.47 141.758 1160.43 141.297 1160.42 140.844C1159.78 108.333 1159.78 108.333 1188.47 108.333C1221.96 108.333 1255.45 108.333 1290.13 108.333Z",
    fill: "#D21D71"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1327.24 0C1354.49 0.00166186 1354.49 0.00166355 1354.49 22.7325C1354.49 25.9047 1354.13 29.1145 1354.56 32.2416C1355.65 40.2907 1352.45 43.3896 1342.74 43.3324C1285.33 42.9942 1227.91 43.0249 1170.5 43.3145C1162.12 43.3568 1159.4 40.6953 1160.47 33.8689C1160.54 33.4243 1160.48 32.9634 1160.47 32.5106C1159.65 0.000313325 1159.65 0.000333575 1196.53 0.000311779C1239.59 0.000289984 1282.65 0.000247917 1327.24 0Z",
    fill: "#645EFF"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_d_9306_1300",
    x: 270,
    y: 0,
    width: 278.053,
    height: 268,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 4
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 2
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.25 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_9306_1300"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_9306_1300",
    result: "shape"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter1_d_9306_1300",
    x: 1729.02,
    y: 0,
    width: 245.74,
    height: 268,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 4
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 2
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.25 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_9306_1300"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_9306_1300",
    result: "shape"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter2_d_9306_1300",
    x: 0,
    y: 0,
    width: 256.547,
    height: 268,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 4
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 2
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.25 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_9306_1300"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_9306_1300",
    result: "shape"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter3_d_9306_1300",
    x: 572.773,
    y: 0,
    width: 234.934,
    height: 268,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 4
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 2
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.25 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_9306_1300"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_9306_1300",
    result: "shape"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter4_d_9306_1300",
    x: 853.699,
    y: 0,
    width: 245.74,
    height: 268,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 4
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 2
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.25 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_9306_1300"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_9306_1300",
    result: "shape"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter5_d_9306_1300",
    x: 1415.55,
    y: 0,
    width: 267.354,
    height: 268,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 4
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 2
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.25 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_9306_1300"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_9306_1300",
    result: "shape"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter6_d_9306_1300",
    x: 2042.49,
    y: 0,
    width: 202.506,
    height: 268,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 4
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 2
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.25 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_9306_1300"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_9306_1300",
    result: "shape"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter7_d_9306_1300",
    x: 1156.25,
    y: 0,
    width: 202.516,
    height: 268,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 4
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 2
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.25 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_9306_1300"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_9306_1300",
    result: "shape"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgNoCoPilot);
export default __webpack_public_path__ + "static/media/NoCoPilot.09ba69ebb396a024273c13393fb39788.svg";
export { ForwardRef as ReactComponent };